import script from "./Peleadores.vue?vue&type=script&setup=true&lang=js"
export * from "./Peleadores.vue?vue&type=script&setup=true&lang=js"

import "./Peleadores.vue?vue&type=style&index=0&id=18aca9ff&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18aca9ff"]])

export default __exports__